module.exports = __webpack_public_path__ + "static/img/cans.ae80106.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bublyside/cans.png
// module id = jQVi
// module chunks = 0